import { getIconProps, type IconProps } from '#types'

/**
 * Minus icon - subtract / decrement indicator
 *
 * Used for stepper "remove" buttons, collapse, and remove actions.
 */
export function MinusIcon({ strokeWidth = 1.5, ...props }: IconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 24 24">
      <path
        d="M3 12H21"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
